import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font } from '~styles/theme.stylex';
const DESKTOP = '@media (min-width: 60rem)';

// Spot page shell. Mobile = single column in Flutter order (carousel, title,
// description, then the info cards). Desktop (>=60rem) = carousel + title +
// description on the left, info cards in a sticky sidebar on the right.
export const styles = {
  container: {
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    maxWidth: "xf2d64e x1snfz9g",
    paddingTop: "x12t3zde",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBottom: "x58caik x14uxbcq",
    display: "x1lliihq x2399xu",
    gridTemplateColumns: "x1noms9b xv7d8bh",
    columnGap: "x1o1pmfc x15xt94",
    alignItems: "x1qjc9v5 x1x5jrqe",
    $$css: true
  },
  col1: {
    gridColumn: "xm5moh1 x1qjfwf0",
    gridColumnStart: null,
    gridColumnEnd: null,
    $$css: true
  },
  side: {
    gridColumn: "xm5moh1 x1tiv5ds",
    gridColumnStart: null,
    gridColumnEnd: null,
    gridRow: "x15daork x1xbuo3n",
    gridRowStart: null,
    gridRowEnd: null,
    position: "x1uhb9sk x1bn53jn",
    top: "xati1ur",
    alignSelf: "x1y8v6su",
    display: "x1lliihq x14bey26",
    flexDirection: "xdt5ytf",
    $$css: true
  },
  title: {
    marginTop: "xj1urod",
    marginBottom: "x1gr9t9r",
    fontSize: "x579bpy x1ak8kg7",
    lineHeight: "x1u7k74",
    fontWeight: "x1sl8krj",
    color: "xtt1gjl",
    $$css: true
  },
  description: {
    fontSize: "x1lkfr7t",
    lineHeight: "x1evy7pa",
    marginTop: "xdj266r",
    marginBottom: "x1eq25fj",
    color: "xtt1gjl",
    $$css: true
  }
};